import { connect } from 'react-redux';

import SearchParamsActions from 'reducers/searchParams';
import SearchCoursesActions from 'reducers/searchCourses';
import SearchFiltersActions from 'reducers/searchFilters';
import TimeSlotsActions from 'reducers/timeSlots';
import { matchRoute } from 'utils/routeHelpers';
import { HOME } from 'utils/routes';

const mapStateToProps = ({
  location,
  router: { location: { pathname } },
  search: { searchParams },
}) => ({
  ...searchParams.searchValues,
  isHome: matchRoute(HOME, pathname),
  searchFormError: searchParams.searchFormError,
  location: searchParams.searchValues.location,
  locationFilter: searchParams.filterValues.locationFilter,
  dateFilter: searchParams.filterValues.dateFilter,
  currentLocation: location,
});

const mapDispatchToProps = {
  ...SearchParamsActions,
  ...SearchCoursesActions,
  ...SearchFiltersActions,
  ...TimeSlotsActions,
};

export default connect(mapStateToProps, mapDispatchToProps);
